import { IDateRange } from '../../../types/dateRange';
import { CHANGE_DEPARTURE_DATES } from '../../../actions/filters';
import { TReduxActions } from '../../../types/redux';
import { defaultState } from './defaultState';

export function departureDatesReducer(state: IDateRange = defaultState, action: TReduxActions): IDateRange {
  switch (action.type) {
    case CHANGE_DEPARTURE_DATES: {
      return action.payload;
    }

    default:
      return state;
  }
}
